import type { Menu } from '@/menus/types.ts';
import baseData from './base-data';
import workflow from './workflow.ts';

export default [
  {
    code: 'SYSTEM',
    icon: 'menu-system',
    label: '后台管理',
    placement: 'bottom',
    children: [
      {
        code: 'SYSTEM_OVERVIEW',
        icon: 'menu-system-settings',
        label: '系统概览',
        remark: '后台管理概览与通讯录管理入口',
        path: '/system/overview',
      },
      {
        code: 'SYSTEM_CONTACTS',
        icon: 'menu-contacts',
        label: '通讯录管理',
        remark: '企业通讯录维护',
        path: '/system/contacts',
      },
      {
        code: 'SYSTEM_SETTINGS',
        icon: 'menu-system-settings',
        label: '企业设置',
        remark: '企业管理员维护企业资料',
        path: '/system/settings',
      },
      {
        code: 'SYSTEM_MENUS',
        icon: 'menu-roles',
        label: '菜单权限',
        remark: '企业导航菜单权限管理',
        path: '/system/menus',
      },
      {
        code: 'SYSTEM_LOGS',
        icon: 'menu-contacts',
        label: '操作日志',
        remark: '企业操作日志管理',
        path: '/system/logs',
      },
      {
        code: 'NOTIFICATION',
        icon: 'menu-notification',
        label: '消息通知',
        remark: '管理企业消息',
        path: '/system/notification',
      },
      ...baseData,
      ...workflow,
    ],
  },
] satisfies Menu[];
